import { render, staticRenderFns } from "./AnnouncementBanners.vue?vue&type=template&id=3f2c13c4&"
import script from "./AnnouncementBanners.vue?vue&type=script&lang=js&"
export * from "./AnnouncementBanners.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports